import React from "react";
import Diagnostic from "./services/Diagnostic";
import Software from "./services/Software";
import Automation from "./services/Automation";

const Services = () => {
  return (
    <div className="bg-white scroll-mt-24 xl:scroll-mt-32" id="services">
      <div className="text-black w-3/4 mx-auto">
        <div className="xl:pt-40 pt-16 xl:pb-24 pb-8">
          <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4 xl:text-center">Serviços</p>
          <h2 className="text-3xl xl:text-5xl font-semibold xl:text-center">O que fazemos</h2>
        </div>
        <Diagnostic />
        <Software />
        <Automation />
      </div>
    </div>
  );
};

export default Services;
